import { Link as RouterLink } from 'react-router-dom'
import { Grid, Card, CardActionArea, CardContent, Box, Typography, Skeleton } from '@mui/material'
import { People, Explore, Groups } from '@mui/icons-material'

interface StatsSummaryCardsProps {
  totalUsers?: number
  totalAdventures?: number
  totalGroups?: number
  isLoading?: boolean
}

export function StatsSummaryCards({
  totalUsers,
  totalAdventures,
  totalGroups,
  isLoading,
}: StatsSummaryCardsProps) {
  const cards = [
    {
      label: 'Total Users',
      value: totalUsers,
      icon: People,
      color: 'primary.main',
      to: '/users',
    },
    {
      label: 'Adventures',
      value: totalAdventures,
      icon: Explore,
      color: 'secondary.main',
      to: '/adventures',
    },
    {
      label: 'Total Groups',
      value: totalGroups,
      icon: Groups,
      color: 'success.main',
      to: '/groups',
    },
  ]

  return (
    <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
      {cards.map(({ label, value, icon: Icon, color, to }) => (
        // Three across at every width: one per row on a phone was a screen of three big numbers
        // before anything actionable. Each opens the page behind the number.
        <Grid item xs={4} key={label}>
          <Card sx={{ border: '2px solid', borderColor: color, height: '100%' }}>
            <CardActionArea component={RouterLink} to={to} sx={{ height: '100%' }}>
              <CardContent sx={{ p: { xs: 1.25, sm: 2 }, '&:last-child': { pb: { xs: 1.25, sm: 2 } } }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                      {label}
                    </Typography>
                    {isLoading ? (
                      <Skeleton variant="text" width={60} height={36} />
                    ) : (
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.125rem' } }}
                      >
                        {value?.toLocaleString() ?? '—'}
                      </Typography>
                    )}
                  </Box>
                  <Icon sx={{ fontSize: 48, color, opacity: 0.3, display: { xs: 'none', md: 'block' } }} />
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
